export class InitializePermissionsState {
  static readonly type = '[Permissions] InitializeState';
}
